export const MENU_ICON_PATHS = {
  policyDetails: '/menu-icons/policy-details.png',
  aiAssist: '/menu-icons/map-pin-sparkles-black.svg',
  loginAsUser: '/menu-icons/log-in-as-user.png',
  dataDashboard: '/menu-icons/data-dashboard.png',
  usersGroups: '/menu-icons/user.png',
  users: '/menu-icons/user.png',
  groups: '/menu-icons/groups.png',
  domains: '/menu-icons/domains.png',
  feedback: '/menu-icons/feedback.png',
  reportIssue: '/menu-icons/report-an-issue.png',
  suggestFeature: '/menu-icons/suggest-a-feature.png',
  about: '/menu-icons/about.png',
  signOut: '/menu-icons/sign-out.png',
  more: '/menu-icons/hamburger-menu.png',
  actionsMenu: '/menu-icons/3-dots.png',
  upload: '/menu-icons/upload.png',
  export: '/menu-icons/export.png',
  leftArrows: '/menu-icons/left-arrows.png',
  rightArrows: '/menu-icons/right-arrows.png',
  upArrow: '/menu-icons/up-arrow.png',
  downArrow: '/menu-icons/down-arrow.png'
} as const;

